import { esES as coreES } from '@mui/material/locale';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { esES } from '@mui/x-data-grid';
import components from './fingo/components';
import breakpoints from './breakpoints';
import palette from './fingo/palette';
import typography from './fingo/typography';
import branding from './fingo/branding';

const theme = createTheme(
  {
    palette,
    breakpoints,
    typography,
    components,
    branding,
  },
  coreES,
  esES,
);

theme.typography.body2 = {
  ...theme.typography.body2,
  [theme.breakpoints.down('md')]: {
    fontSize: 10,
  },
};

export default responsiveFontSizes(theme);
